var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "details",
    { staticClass: "filter-block", attrs: { open: _vm.isOpen } },
    [
      _c("summary", { staticClass: "filter-block__head" }, [
        _c("span", [
          _c(
            "label",
            _vm._b(
              {},
              "label",
              _vm.isLabel ? { for: _vm.searchInputId } : {},
              false
            ),
            [_c("strong", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.name))])]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "filter-block__icon" })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._t("header"),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "scrollable",
              staticClass: "filter-block__list",
              class: { "has-scroll": _vm.scrollable }
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm._t("footer")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }